import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  access_token: null,
  refresh_token: null,
  role: null,
  isLoggedIn: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      const { user, access_token, refresh_token, role } = action.payload;
      state.user = user;
      state.access_token = access_token;
      state.refresh_token = refresh_token;
      state.role = role || user?.user_type || user?.role;
      state.isLoggedIn = true;

      localStorage.setItem("access_token", access_token);
      localStorage.setItem("refresh_token", refresh_token);
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("role", role || user?.user_type || user?.role);
    },

    logout: (state) => {
      state.user = null;
      state.access_token = null;
      state.refresh_token = null;
      state.role = null;
      state.isLoggedIn = false;

      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("user");
      localStorage.removeItem("role");
    },

    updateUser: (state, action) => {
      state.user = { ...state.user, ...action.payload };
      localStorage.setItem("user", JSON.stringify(state.user));
    },

    updateTokens: (state, action) => {
      if (action.payload.access_token) {
        state.access_token = action.payload.access_token;
        localStorage.setItem("access_token", action.payload.access_token);
      }
      if (action.payload.refresh_token) {
        state.refresh_token = action.payload.refresh_token;
        localStorage.setItem("refresh_token", action.payload.refresh_token);
      }
    },
  },
});

export const { loginSuccess, logout, updateUser, updateTokens } =
  authSlice.actions;
export default authSlice.reducer;
